import DataGrid from '../..';
import {
	ISelectionChangedEventArgs,
	ISelectionChangingEventArgs
} from '../../../../entities/EventArgs';

async function onSelectionChange(this: DataGrid, items: Array<any>, selectedIds: Array<string>) {
	const selectionChangingArgs: ISelectionChangingEventArgs = {
		items,
		selectedIds
	};

	await this.emit<ISelectionChangingEventArgs>(
		'event:OnSelectionChanging',
		selectionChangingArgs
	);

	const uniqueFieldName = this.getUniqueDataField();

	this.__proxyChanging.rows = this.rows.map(r => ({
		...r,
		selected: selectionChangingArgs.selectedIds.includes(r.data[uniqueFieldName])
	}));
	this.__proxyChanging.selectedRowsData = selectionChangingArgs.items;
	this.__proxyChanging.selectedRowKeys = selectionChangingArgs.selectedIds;

	this.emit<ISelectionChangedEventArgs>('event:OnSelectionChanged', {
		items: selectionChangingArgs.items
	});
}

export { compareDeletingRowByCellType } from './onCommitChanges';

export { onSelectionChange };

export { onBeforeToolbarItemClick, onColumnButtonClick } from './DataGridButtonEvents';

export {
	onGridUpdated,
	onRowRemoved,
	onRowUpdated,
	onRowInserted,
	onRowInserting,
	onRowUpdating,
	onRowRemoving,
	onRowDoubleClick
} from './rowEvents';
